module.exports = __webpack_public_path__ + "img/1529804832.240f28c0.jpg";